import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VuexPersistence from 'vuex-persist';

import options from './modules/options';
import load from './modules/load';
import user from './modules/user';
import auth from './modules/auth';

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer(val) {
    return {
      user: val.user, // 只对user模块作数据持久化
    };
  },
});

Vue.use(Vuex);
Vue.use(VueAxios, axios);

const store = new Vuex.Store({
  modules: {
    load,
    options,
    user,
    auth,
  },
  plugins: [vuexLocal.plugin],
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js